import { createClient } from "@supabase/supabase-js";
import { assertValidSupabaseUrl, normalizeViteEnvString } from "@/lib/viteEnv";

const supabaseUrl = normalizeViteEnvString(import.meta.env.VITE_SUPABASE_URL as string | undefined);
const supabaseAnonKey = normalizeViteEnvString(
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ??
    (import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY as string | undefined),
);

if (!supabaseUrl || !supabaseAnonKey) {
  const hint =
    "See docs/LOCAL_DEV.md: .env in project root must set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (no quotes needed). Restart npm run dev after saving. If you use .env.local, it overrides .env.";
  if (import.meta.env.DEV) {
    const hasUrlName = "VITE_SUPABASE_URL" in import.meta.env;
    const hasKeyName = "VITE_SUPABASE_ANON_KEY" in import.meta.env;
    console.error(`[Hey Bodhi] ${hint}`);
    console.error(
      `[Hey Bodhi] Debug: VITE_SUPABASE_URL defined in bundle=${String(hasUrlName)}, VITE_SUPABASE_ANON_KEY defined=${String(hasKeyName)}. Lengths: url=${supabaseUrl.length}, key=${supabaseAnonKey.length}.`
    );
  }
  throw new Error(`Supabase env missing: ${hint}`);
}

try {
  assertValidSupabaseUrl(supabaseUrl);
} catch (e) {
  if (import.meta.env.DEV) {
    console.error("[Hey Bodhi]", e);
  }
  throw e;
}

if (import.meta.env.DEV && supabaseAnonKey && !supabaseAnonKey.startsWith("eyJ") && !supabaseAnonKey.startsWith("sb_publishable_")) {
  console.warn(
    "[Hey Bodhi] VITE_SUPABASE_ANON_KEY usually starts with eyJ… (JWT). Confirm you copied the anon public key, not the service_role key."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
